/******/ (() => {
var __webpack_exports__ = {};

Shopify.theme.jsCollection = {
  init: function($section) {

    Shopify.theme.jsCollection = $.extend(this, Shopify.theme.getSectionData($section));

    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ]);
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    // IMPORTANT: delegated event, because filter bar is replaced after ajax
    $(document).off('change.collectionSortFilter', '#tag_filter, #sort-by');
    $(document).on('change.collectionSortFilter', '#tag_filter, #sort-by', function() {
      Shopify.theme.jsCollection.filterURL();
    });

    if ($('[data-option-filter]').length) {
      $('[data-tag-filter-checkbox]:checked').each(function(){
        Shopify.theme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      });
    }

    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      Shopify.theme.breadcrumbs.init(this.number_of_pages);
    }

    $('body').off('click.collectionOptionFilter', '[data-option-filter]');
    $('body').on('click.collectionOptionFilter', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      Shopify.theme.jsCollection.multiTagFilter.init($(this));
      Shopify.theme.scrollToTop($('.collection__content'));
    });

    $('body').off('click.collectionClearFilter', '[data-clear-filter]');
    $('body').on('click.collectionClearFilter', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      Shopify.theme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      Shopify.theme.scrollToTop($('.collection__content'));
    });

    // Custom sort dropdown open/close
    $(document).off('click.customSortDropdown', '.custom-sort_by .clickable-dropdown');
    $(document).on('click.customSortDropdown', '.custom-sort_by .clickable-dropdown', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $parent = $(this).closest('.custom-sort_by');

      $('.custom-sort_by').not($parent).removeClass('active');
      $parent.toggleClass('active');
    });

    $(document).off('click.customSortWrapper', '.custom-sort_by');
    $(document).on('click.customSortWrapper', '.custom-sort_by', function (e) {
      e.stopPropagation();
    });

    $(document).off('click.customSortClose');
    $(document).on('click.customSortClose', function () {
      $('.custom-sort_by').removeClass('active');
    });

    $(document).off('click.customSortItem', '.custom-sort_by .sorting-list li');
    $(document).on('click.customSortItem', '.custom-sort_by .sorting-list li', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $li = $(this);
      var selectedValue = $li.attr('value');
      var selectedText = $.trim($li.text());

      if (!selectedValue) return;

      window.selectedCustomSortValue = selectedValue;
      window.selectedCustomSortText = selectedText;

      $('.custom-sort_by .clickable-dropdown span').text(selectedText);

      var $select = $('.collection__sort-by-filter select, #sort-by').first();

      if ($select.length) {
        $select.val(selectedValue);

        $select.trigger('change');
      }

      $li.addClass('active').siblings().removeClass('active');

      $('.custom-sort_by').removeClass('active');
    });

    this.restoreCustomSortDropdown();

    $(document).ready(function () {
      $('.customPriceRangeSliderContainer').each(function () {
        var $container = $(this);

        var rangeSlider = $container.find('#priceSlider')[0];

        if (!rangeSlider || rangeSlider.noUiSlider) return;

        var filterMinValue = parseFloat($container.attr('data-minValue')) || 0;
        var currentMaxValue = parseFloat($container.attr('data-currentMaxValue')) || 0;
        var filterMaxValue = parseFloat($container.attr('data-maxValue')) || 0;

        var moneyFormat = wNumb({
          decimals: 2,
          thousand: ',',
          prefix: '$'
        });

        noUiSlider.create(rangeSlider, {
          start: [filterMinValue, currentMaxValue],
          step: 0.01,
          range: {
            min: [0],
            max: [filterMaxValue]
          },
          format: moneyFormat,
          connect: true
        });

        rangeSlider.noUiSlider.on('update', function (values) {
          $container.find('#slider-value-min').html(values[0]);
          $container.find('#slider-value-max').html(values[1]);

          var minValueWithoutDollar = values[0].replace('$', '').replace(/,/g, '');
          var maxValueWithoutDollar = values[1].replace('$', '').replace(/,/g, '');

          var $priceRangeWrapper = $container.next('.faceted-filter-group-display__price-range');

          $priceRangeWrapper.find('.filterMinValueInput').val(minValueWithoutDollar);
          $priceRangeWrapper.find('.filterMaxValueInput').val(maxValueWithoutDollar);
        });
      });
    });

    $(document).off('click.priceRangeSubmit', '.faceted-filter-group-display__submit button');
    $(document).on('click.priceRangeSubmit', '.faceted-filter-group-display__submit button', function (e) {
      e.preventDefault();

      var $priceRangeWrapper = $(this)
        .closest('.faceted-filter-group-display__submit')
        .siblings('.faceted-filter-group-display__price-range');

      var minInput = $priceRangeWrapper.find('.filterMinValueInput')[0];
      var maxInput = $priceRangeWrapper.find('.filterMaxValueInput')[0];

      var currentUrl = new URL(window.location.href);

      // old price params remove
      if (minInput && minInput.name) {
        currentUrl.searchParams.delete(minInput.name);
      }

      if (maxInput && maxInput.name) {
        currentUrl.searchParams.delete(maxInput.name);
      }

      // pagination reset
      currentUrl.searchParams.delete('page');

      // new price values add
      if (minInput && minInput.name && minInput.value !== '') {
        currentUrl.searchParams.set(minInput.name, minInput.value);
      }

      if (maxInput && maxInput.name && maxInput.value !== '') {
        currentUrl.searchParams.set(maxInput.name, maxInput.value);
      }

      window.location.href = currentUrl.toString();
    });

    $(document).on('click', '.mobile-filter .toggle-filter', function (e) {
      if ($(window).width() > 798) return;

      e.preventDefault();
      e.stopPropagation();

      var $toggle = $(this);
      var $parent = $toggle.parent();
      var $mainParent = $toggle.closest('.collection--filter_bar');
      var $sidebar = $mainParent.find('.sidebar-section');

      $parent.toggleClass('active');
      $sidebar.stop(true, true).slideToggle(300);
    });

    $(document).on('click', function () {
      if ($(window).width() > 798) return;

      $('.mobile-filter .toggle-filter').parent().removeClass('active');
      $('.collection--filter_bar .sidebar-section:visible').stop(true, true).slideUp(300);
    });

    $(document).on('click', '.collection--filter_bar .sidebar-section, .mobile-filter .toggle-filter', function (e) {
      if ($(window).width() > 798) return;

      e.stopPropagation();
    });
  },

  restoreCustomSortDropdown: function() {
    var selectedValue = window.selectedCustomSortValue || $('#sort-by').val() || $('.collection__sort-by-filter select').val();
    if (!selectedValue) return;
    var $selectedLi = $('.custom-sort_by .sorting-list li[value="' + selectedValue + '"]');
    if ($selectedLi.length) {
      var selectedText = window.selectedCustomSortText || $.trim($selectedLi.text());
      $('.custom-sort_by .clickable-dropdown span').text(selectedText);
      $selectedLi.addClass('active').siblings().removeClass('active');
      $('.collection__sort-by-filter select, #sort-by').val(selectedValue);
    }
  },

  filterURL: function() {

    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname');

    if (Shopify.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    if ($('#sort-by').length) {
      query = $('#sort-by').val();
    } else if ($('.collection__sort-by-filter select').length) {
      query = $('.collection__sort-by-filter select').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length) {
      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()) {
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all') {
          if ($.inArray(urlTag, selectedOptions) > -1) {
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    $.each(selectedOptions, function(i, value) {
      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }
    });

    Shopify.theme.queryParameters.sort_by = query;
    query = '?' + $.param(Shopify.theme.queryParameters);

    this.processUrl(path, currentTags, query);
  },

  processUrl: function (path, tags, query) {
    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';

    urlString = path + tags + query;

    this.updateView(urlString);
  },

  updateView: function(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      },
      dataType: "html"
    }).then(function(data) {

      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMain = $('[data-collection-main]');

      const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      const filteredData = $(data).find('.collection-matrix__wrapper');
      const filteredPageLinks = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');
      const filteredFilterBar = $(data).find('.collection--filter_bar');

      $breadcrumbContainer.html(filteredBreadcrumb);

      $collectionMain.empty();

      if (filteredFilterBar.length) {
        $collectionMain.append(filteredFilterBar);
      }

      if (filteredData.length) {
        $collectionMain.append(filteredData);
      } else {
        $collectionMain.append(noProducts);
      }

      if (filteredPageLinks.length) {
        $collectionMain.append(filteredPageLinks);
      }

      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      // Restore custom sort after ajax html replace
      Shopify.theme.jsCollection.restoreCustomSortDropdown();

      if (Shopify.theme_settings.enable_shopify_collection_badges == true) {
        Shopify.theme.productReviews();
      }

      if ($('[data-custom-pagination]').length) {
        Shopify.theme.infiniteScroll.update();
      }
    });
  },

  multiTagFilter: {
    init: function ($el) {

      this.showSelectedFilter($el);

      Shopify.theme.jsCollection.filterURL();

      var urlIndex;
      if (Shopify.routes.root_url.length > 1) {
        urlIndex = 3;
      } else {
        urlIndex = 2;
      }

      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }
    },

    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');
        Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
      }
    },

    clearSelectedFilter: function ($el) {
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active').find('input').prop("checked", false);
      $filterItem.siblings().removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]').addClass('is-hidden');

      Shopify.theme.jsCollection.filterURL();
    }
  },

  unload: function($section) {
    $(document).off('change.collectionSortFilter', '#tag_filter, #sort-by');
    $('body').off('click.collectionOptionFilter', '[data-option-filter]');
    $('body').off('click.collectionClearFilter', '[data-clear-filter]');

    $(document).off('click.customSortDropdown', '.custom-sort_by .clickable-dropdown');
    $(document).off('click.customSortWrapper', '.custom-sort_by');
    $(document).off('click.customSortClose');
    $(document).off('click.customSortItem', '.custom-sort_by .sorting-list li');

    $('[data-reset-filters]').off();

    Shopify.theme.breadcrumbs.unload();
  }
};

/******/ })();